export const TASK_REPORTS_COMMON_COLUMNS = {
  projectCode: "projectCode",
  module: "module",
  categoryTitle: "categoryTitle",
}
